import { Wizard } from 'react-use-wizard';
import UserProfileWrapper from './UserProfileWrapper';
import Header from './Header';
import { StyledBox } from './userProfileWizard.style.js';
import { ForwardedRef, forwardRef } from 'react';
import AddRoleStep from './Steps/AddRoleStep.js';
import AddSeniorityStep from './Steps/AddSeniorityStep.js';
import AddInterestsStep from './Steps/AddInterestsStep.js';
import AddWorkHoursStep from './Steps/AddWorkHoursStep.js';
import { myAccountSelector } from 'state/selectors/account';
import { useSelector } from 'react-redux';

/**
 * UserProfileWizardComponent renders a multi-step user profile wizard.
 */
function UserProfileWizardComponent(
  props: {
    setOpenWizard: (value: boolean) => void;
    setOpenSnoozeSnackBar: (value: boolean) => void;
    setOpenCompleteSnackBar: (value: boolean) => void;
  },
  ref: ForwardedRef<HTMLDivElement>
): JSX.Element {
  const { setOpenWizard, setOpenSnoozeSnackBar, setOpenCompleteSnackBar } =
    props;
  const account = useSelector(myAccountSelector);
  const { name } = account;

  return (
    <StyledBox
      direction='column'
      padding={2}
      ref={ref}
      data-cy='user-profile-wizard'
    >
      <Wizard
        header={
          <Header
            userName={name}
            setOpenWizard={setOpenWizard}
            setOpenSnoozeSnackBar={setOpenSnoozeSnackBar}
          />
        }
        wrapper={<UserProfileWrapper />}
      >
        <AddRoleStep />
        <AddSeniorityStep />
        <AddInterestsStep />
        <AddWorkHoursStep
          setOpenWizard={setOpenWizard}
          setOpenCompleteSnackBar={setOpenCompleteSnackBar}
        />
      </Wizard>
    </StyledBox>
  );
}

export const UserProfileWizard = forwardRef(UserProfileWizardComponent);
